<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.13333 6.2666H14.8M4.13333 6.2666L5.03464 16.181C5.12829 17.2112 5.99202 17.9999 7.02643 17.9999H11.9069C12.9413 17.9999 13.805 17.2112 13.8987 16.181L14.8 6.2666M4.13333 6.2666H2M14.8 6.2666H16.9333" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    <path d="M6.2666 2H12.6666" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
  </svg>
</template>

<script>
export default {
  name: "Trash"
}
</script>
